import React from 'react';

const FeedbackBar = ({ message, type = 'info', visible = false }) => {
  if (!message) return null;

  const getBackgroundColor = (type) => {
    switch (type) {
      case 'success': return 'bg-green-500';
      case 'error': return 'bg-red-500';
      case 'warning': return 'bg-orange-500';
      case 'info': return 'bg-blue-500';
      default: return 'bg-gray-800';
    }
  };

  const getAnimationClass = (visible) => {
    return visible 
      ? 'animate-slide-in-down opacity-100 translate-y-0' 
      : 'animate-slide-out-up opacity-0 -translate-y-full';
  };

  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-50 px-5 py-4 ${getBackgroundColor(type)} text-white text-center font-medium transition-all duration-300 ease-in-out ${getAnimationClass(visible)}`}
    >
      {message}
    </div>
  );
};

export default FeedbackBar;


